import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SpgFormPage } from './spg-form.page';

const routes: Routes = [
  {
    path: '',
    component: SpgFormPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SpgFormPageRoutingModule {}
